import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Dialog, Transition } from '@headlessui/react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import {
  HiOutlineHeart,
  HiPlus,
  HiOutlineUser,
  HiOutlineBuildingOffice2,
  HiOutlineMapPin,
  HiOutlineBuildingLibrary,
  HiOutlineGlobeEuropeAfrica,
  HiChevronLeft,
  HiChevronRight,
  HiChevronDown,
  HiChevronUp,
  HiMagnifyingGlass,
  HiOutlineTrash,
  HiEllipsisVertical,
  HiOutlineSparkles,
  HiOutlineCube
} from "react-icons/hi2";
import dayjs from "dayjs";
import OptimizedUserList from "../../components/ui/OptimizedUserList";
import { API_URL } from "../../config";

const getDoctorInitials = (name) => {
  if (!name) return "DR";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const formatBirthDate = (birth) => {
  if (!birth) return "—";
  const d = dayjs(birth);
  if (!d.isValid()) return birth;
  const monthsRo = [
    "ian.", "feb.", "mar.", "apr.", "mai", "iun.",
    "iul.", "aug.", "sept.", "oct.", "nov.", "dec."
  ];
  const day = String(d.date()).padStart(2, '0');
  const month = monthsRo[d.month()];
  const year = d.year();
  return `${day} ${month} ${year}`;
};

function DashboardCard07physicians() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const location = useLocation();
  const { item: initialData } = location.state || {};
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);

  const [data, setData] = useState([]);
  const [Manage1, setManage1] = useState([]);
  const [specData, setspecData] = useState([]);
  const [inst, setInst] = useState([]);
  const [instData, setinstData] = useState([]);
  const [userinstData, setUserinstData] = useState([]);
  const [prodphys, setProdphys] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [Manage, setManage] = useState([]);
  const [city, setCity] = useState([]);
  const [city1, setCity1] = useState([]);
  const [instcity, setinstCity] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQuery1, setSearchQuery1] = useState('');
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [user, setUser] = useState(null);
  const [selecteduser1, setSelecteduser1] = useState(null);
  const [selectedInstitutionId, setSelectedInstitutionId] = useState(null);
  const [selectedInstitutionId1, setSelectedInstitutionId1] = useState(null);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showGrid, setShowGrid] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const token = localStorage.getItem('jwtToken');

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false);
    }, 600);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, [token]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/speciality`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setspecData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [token]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/physiciansinstitute`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setUserinstData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [token]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/institutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setinstData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await axios.get(`${API_URL}/api/usersproducersacces`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const userAccess = response1.data
          .filter((i) => i.user_id === selectedEditRowData?.user_id)
          .map((i) => i.producer_or_producer_group_id);

        const response2 = await axios.get(`${API_URL}/api/physiciansinproduct`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const val = response2.data.filter((i) =>
          userAccess.includes(i.producer_id)
        );
        setProdphys(val);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedEditRowData, token]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adressinstitutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setinstCity(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [token]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adress`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setCity(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [token]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/product`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setInst(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [token]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/productcategory`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setCity1(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [token]);

  const fetchManageData = () => {
    if (!selectedEditRowData?.user_id) return;
    axios
      .get(`${API_URL}/api/usersphysicians`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const users = response.data.filter(
          (item) => item.user_id === selectedEditRowData?.user_id
        );

        if (users.length > 0) {
          const subordinateUserId = users.map((item) => item.physician_id);

          axios
            .get(`${API_URL}/api/physician`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              const matchedUsers = response.data.filter((item) =>
                subordinateUserId.includes(item.physician_id)
              );
              setData(matchedUsers);
            })
            .catch((error) => {
              console.error("Error fetching users data:", error);
            });
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching manage data:", error);
      });
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/api/physician`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const uniqueManageData = response.data;
        fetchManageData();
        setManage1(uniqueManageData);
      })
      .catch((error) => {
        console.error("Error fetching users data:", error);
      });
  }, [selectedEditRowData, token]);

  useEffect(() => {
    const selectProducerIds = data.map((item) => item.physician_id);
    const select = Manage1.filter((item) => !selectProducerIds.includes(item.physician_id));
    setManage(select);
  }, [data, Manage1, searchQuery]);

  const uniqueUsers = data.filter((user) => {
    const query = searchQuery1.toLowerCase();
    const matchesName = user.user_name_surname?.toLowerCase().includes(query);
    const matchesEmail = user.email?.toLowerCase().includes(query);
    const matchesPhone = user.phone?.toLowerCase().includes(query);

    const matchesSpec = userinstData.some((spec) =>
      spec.physician_id === user.physician_id &&
      spec.spec?.toLowerCase().includes(query)
    );

    const matchesInst = userinstData.some((spec) =>
      spec.physician_id === user.physician_id &&
      spec.inst?.toLowerCase().includes(query)
    );

    return matchesName || matchesEmail || matchesPhone || matchesSpec || matchesInst;
  });

  const totalPages = Math.ceil(uniqueUsers.length / itemsPerPage) || 1;
  const currentItems = uniqueUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [itemsPerPage, searchQuery1]);

  useEffect(() => {
    if (selecteddeleteuser) {
      deleteRowuser();
    }
  }, [selecteddeleteuser]);

  useEffect(() => {
    if (selecteduser1) {
      handleEditRows(selecteduser1);
    }
  }, [selecteduser1]);

  const handleEditRows = (item) => {
    navigate("/physicians/editphysician", { state: { item } });
  };

  const deleteRowuser = async () => {
    if (!selecteddeleteuser) return;

    try {
      await axios.put(
        `${API_URL}/api/deleteusersphysicians`,
        {
          physician_id: selecteddeleteuser.physician_id,
          user_id: selectedEditRowData.user_id
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }
      );
      showToast({
        message: "Asocierea medicului a fost ștearsă!",
        type: "success",
        icon: <FaRegCheckCircle className="text-emerald-600 dark:text-emerald-500" />,
      });
      setSelecteddeleteuser(null);
      fetchManageData();
    } catch (error) {
      console.error("Error deleting user physician:", error);
      showToast({
        message: "Eroare la ștergerea asocierii!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
      setSelecteddeleteuser(null);
    }
  };

  const handleOpenRows = () => {
    setOpen(true);
  };

  const handleToggleUser = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleSave = async () => {
    if (!selectedUsers || !Array.isArray(selectedUsers) || selectedUsers.length === 0) {
      showToast({
        message: "Selectează cel puțin un medic!",
        type: "warning",
        icon: <FaRegTimesCircle className="text-amber-600 dark:text-amber-500" />,
      });
      return;
    }

    try {
      await axios.post(
        `${API_URL}/api/usersphysicians`,
        {
          user_id: selectedEditRowData.user_id,
          physician_ids: selectedUsers,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }
      );

      setOpen(false);
      fetchManageData();
      showToast({
        message: "Medicii au fost asociați cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-emerald-600 dark:text-emerald-500" />,
      });
      setSelectedUsers([]);
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la salvarea medicilor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleButtonClick = async () => {
    setIsLoading(true);
    try {
      await handleSave();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full">
      {showGrid ? (
        <div className="bg-white dark:bg-gray-800 border border-[#E7EAF0] dark:border-gray-700/60 rounded-2xl p-7 shadow-[0_4px_18px_rgba(20,31,56,0.05)] animate-pulse">
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-44 mb-4"></div>
          <div className="h-40 bg-gray-100 dark:bg-gray-700/50 rounded-xl"></div>
        </div>
      ) : (
        <div className="bg-white dark:bg-gray-800 border border-[#E7EAF0] dark:border-gray-700/60 rounded-[14px] sm:rounded-2xl shadow-[0_4px_14px_rgba(22,31,50,0.04)] overflow-hidden">
          {/* Card Header */}
          <div className="px-6 py-4 border-b border-[#F1F5F9] dark:border-gray-700/60 flex flex-col sm:flex-row sm:items-center justify-between gap-3.5">
            {/* Header Left: Icon, Title & Subtitle */}
            <div className="flex items-center gap-3">
              <div className="w-[34px] h-[34px] rounded-[10px] bg-[#F1EEFF] dark:bg-indigo-950/60 text-[#6755E8] dark:text-indigo-400 flex items-center justify-center shrink-0">
                <HiOutlineHeart className="w-4 h-4" />
              </div>
              <div>
                <h3 className="text-[15px] font-bold text-[#1E293B] dark:text-gray-100 leading-tight">
                  Doctori favoriți
                </h3>
                <p className="text-xs text-[#64748B] dark:text-gray-400 mt-0.5">
                  Gestionează lista medicilor asociați acestui cont.
                </p>
              </div>
            </div>

            {/* Header Right: Search Field & CTA */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-2.5">
              <div className="relative w-full sm:w-[220px]">
                <HiMagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-3.5 h-3.5 pointer-events-none" />
                <input
                  type="text"
                  className="w-full h-[34px] pl-8 pr-3 rounded-lg border border-[#E2E8F0] dark:border-gray-600 bg-white dark:bg-gray-700/50 text-xs text-[#1E293B] dark:text-gray-100 placeholder:text-gray-400 focus:border-[#6755E8] focus:outline-none focus:ring-2 focus:ring-[#6755E8]/10 transition-all"
                  placeholder="Caută doctor..."
                  value={searchQuery1}
                  onChange={(e) => setSearchQuery1(e.target.value)}
                  aria-label="Caută doctor"
                />
              </div>

              {user?.role === "Admin" && (
                <button
                  type="button"
                  onClick={handleOpenRows}
                  className="h-[34px] px-3.5 rounded-lg bg-[#6755E8] hover:bg-[#5844E3] text-white text-[11px] font-medium inline-flex items-center justify-center gap-1.5 shadow-xs transition-all duration-150 hover:-translate-y-0.5 cursor-pointer shrink-0"
                >
                  <HiPlus className="w-3.5 h-3.5" />
                  <span>Adaugă doctor</span>
                </button>
              )}
            </div>
          </div>

          {/* Modal Adaugare Doctor */}
          <Transition appear show={open} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => setOpen(false)}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/40 backdrop-blur-xs" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-2xl transition-all border border-[#E7EAF0] dark:border-gray-700">
                      <Dialog.Title as="h3" className="text-base font-bold text-[#172033] dark:text-gray-100">
                        Selectează doctor
                      </Dialog.Title>
                      <p className="text-xs text-[#7B8496] dark:text-gray-400 mt-1">
                        Alege medicii pe care dorești să-i asociezi acestui cont.
                      </p>

                      <div className="mt-4 relative">
                        <HiMagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-3.5 h-3.5" />
                        <input
                          type="text"
                          className="w-full h-9 pl-9 pr-3 rounded-lg border border-[#DDE2EA] dark:border-gray-600 bg-[#F8F9FD] dark:bg-gray-700/50 text-xs text-[#263143] dark:text-gray-100 placeholder:text-gray-400 focus:border-[#7161E8] focus:outline-none"
                          placeholder="Căutare medic..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>

                      <div className="mt-3">
                        <OptimizedUserList
                          Manage={Manage}
                          searchQuery={searchQuery}
                          selectedUsers={selectedUsers}
                          handleToggleUser={handleToggleUser}
                          userinstData={userinstData}
                          userspecData={userinstData}
                          specData={specData}
                          instData={instData}
                        />
                      </div>

                      <div className="mt-5 flex justify-end gap-2">
                        <button
                          type="button"
                          className="h-9 px-4 rounded-lg border border-[#DDE2EA] dark:border-gray-600 bg-white dark:bg-gray-800 text-xs font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 cursor-pointer"
                          onClick={() => setOpen(false)}
                        >
                          Anulează
                        </button>

                        <button
                          type="button"
                          className="h-9 px-4 rounded-lg bg-[#6755E8] hover:bg-[#5948D8] text-white text-xs font-semibold shadow-xs disabled:opacity-50 cursor-pointer inline-flex items-center gap-1.5"
                          onClick={handleButtonClick}
                          disabled={isLoading}
                        >
                          {isLoading && (
                            <svg className="animate-spin h-3.5 w-3.5 text-white" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                            </svg>
                          )}
                          <span>{isLoading ? "Se salvează..." : "Salvează"}</span>
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>

          {/* Table Content */}
          {uniqueUsers.length > 0 ? (
            <div>
              {/* Desktop / Tablet Semantic Table */}
              <div className="overflow-x-auto">
                <table className="table-auto w-full text-left border-collapse">
                  {/* Table Header */}
                  <thead>
                    <tr className="bg-[#F8FAFC] dark:bg-gray-900/40 border-b border-[#F1F5F9] dark:border-gray-700/60 h-10 text-[#64748B] dark:text-gray-400 text-[11px] font-semibold uppercase tracking-wider">
                      <th className="px-6 py-2.5 whitespace-nowrap">
                        Nume Prenume
                      </th>
                      <th className="px-4 py-2.5 whitespace-nowrap">
                        Email
                      </th>
                      <th className="px-4 py-2.5 whitespace-nowrap">
                        Telefon
                      </th>
                      <th className="px-4 py-2.5 whitespace-nowrap">
                        Zi de naștere
                      </th>
                      <th className="px-4 py-2.5 whitespace-nowrap">
                        Specialități
                      </th>
                      <th className="px-4 py-2.5 whitespace-nowrap">
                        Categorizarea per produs
                      </th>
                      <th className="px-4 py-2.5 whitespace-nowrap text-center">
                        Acțiuni
                      </th>
                    </tr>
                  </thead>

                  {/* Table Body */}
                  <tbody className="divide-y divide-[#F1F5F9] dark:divide-gray-700/40">
                    {currentItems.map((customer) => {
                      const filteredAdress = userinstData.filter(
                        (i) => i.physician_id === customer.physician_id
                      );

                      const institutionIds1 = prodphys
                        .filter((i) => i.physician_id === customer.physician_id)
                        .map((i) => i.product_id);
                      const filteredAdress1 = prodphys.filter((i) =>
                        institutionIds1.includes(i.product_id)
                      );

                      const isSelected = selectedInstitutionId === customer.physician_id;
                      const isSelected1 = selectedInstitutionId1 === customer.physician_id;

                      return (
                        <React.Fragment key={customer.physician_id}>
                          {/* Main Doctor Row */}
                          <tr
                            className={`hover:bg-[#F8FAFC] dark:hover:bg-gray-800/60 transition-colors ${
                              isSelected || isSelected1 ? "bg-[#F8FAFC] dark:bg-gray-800/80" : ""
                            }`}
                          >
                            {/* Nume Prenume Cell */}
                            <td className="px-6 py-3.5 whitespace-nowrap">
                              <div className="flex items-center">
                                {/* Expand / Collapse Control */}
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedInstitutionId(isSelected ? null : customer.physician_id);
                                    setSelectedInstitutionId1(null);
                                  }}
                                  aria-expanded={isSelected}
                                  aria-label={isSelected ? "Restrânge specialitățile" : "Extinde specialitățile"}
                                  className="w-7 h-7 rounded-lg inline-flex items-center justify-center text-gray-400 hover:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors mr-1.5 shrink-0 cursor-pointer"
                                >
                                  {isSelected ? (
                                    <HiChevronDown className="w-4 h-4" />
                                  ) : (
                                    <HiChevronRight className="w-4 h-4" />
                                  )}
                                </button>

                                {/* Doctor Avatar Initials */}
                                <div className="w-8 h-8 rounded-full bg-[#F1F5F9] dark:bg-gray-700 text-[#334155] dark:text-gray-200 text-xs font-semibold flex items-center justify-center mr-2.5 shrink-0">
                                  {getDoctorInitials(customer.user_name_surname)}
                                </div>

                                {/* Doctor Name */}
                                <button
                                  type="button"
                                  onClick={() => setSelecteduser1(customer)}
                                  className="text-[13px] font-medium text-[#1E293B] dark:text-gray-100 hover:text-[#6755E8] dark:hover:text-indigo-400 text-left transition-colors cursor-pointer"
                                >
                                  {customer.user_name_surname}
                                </button>
                              </div>
                            </td>

                            {/* Email Cell */}
                            <td className="px-4 py-3.5 whitespace-nowrap">
                              <span className="text-[13px] font-normal text-[#64748B] dark:text-gray-400">
                                {customer.email || "—"}
                              </span>
                            </td>

                            {/* Telefon Cell */}
                            <td className="px-4 py-3.5 whitespace-nowrap">
                              <span className="text-[13px] font-normal text-[#64748B] dark:text-gray-400">
                                {customer.phone || "—"}
                              </span>
                            </td>

                            {/* Zi de nastere Cell */}
                            <td className="px-4 py-3.5 whitespace-nowrap">
                              <span className="text-[13px] font-normal text-[#64748B] dark:text-gray-400">
                                {formatBirthDate(customer.birth)}
                              </span>
                            </td>

                            {/* Specialitati Cell */}
                            <td className="px-4 py-3.5 whitespace-nowrap">
                              {filteredAdress.length >= 1 ? (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedInstitutionId(isSelected ? null : customer.physician_id);
                                    setSelectedInstitutionId1(null);
                                  }}
                                  className={`h-[26px] px-2.5 rounded-full text-[11px] font-medium inline-flex items-center gap-1 transition-all cursor-pointer ${
                                    isSelected
                                      ? "bg-[#6755E8] text-white shadow-xs"
                                      : "bg-[#F1EEFF] text-[#6755E8] hover:bg-[#E8E3FF] dark:bg-indigo-950/70 dark:text-indigo-300 dark:hover:bg-indigo-950"
                                  }`}
                                >
                                  <span>
                                    {filteredAdress.length === 1
                                      ? "1 specialitate"
                                      : `${filteredAdress.length} specialități`}
                                  </span>
                                  {isSelected ? (
                                    <HiChevronUp className="w-3 h-3" />
                                  ) : (
                                    <HiChevronDown className="w-3 h-3" />
                                  )}
                                </button>
                              ) : (
                                <span className="h-[24px] px-2.5 rounded-full bg-[#F1F5F9] dark:bg-gray-700/60 text-[#94A3B8] dark:text-gray-400 text-[11px] font-medium inline-flex items-center justify-center">
                                  Fără date
                                </span>
                              )}
                            </td>

                            {/* Categorizarea per produs Cell */}
                            <td className="px-4 py-3.5 whitespace-nowrap">
                              {filteredAdress1.length >= 1 ? (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedInstitutionId1(isSelected1 ? null : customer.physician_id);
                                    setSelectedInstitutionId(null);
                                  }}
                                  className={`h-[26px] px-2.5 rounded-full text-[11px] font-medium inline-flex items-center gap-1 transition-all cursor-pointer ${
                                    isSelected1
                                      ? "bg-[#6755E8] text-white shadow-xs"
                                      : "bg-[#F1EEFF] text-[#6755E8] hover:bg-[#E8E3FF] dark:bg-indigo-950/70 dark:text-indigo-300 dark:hover:bg-indigo-950"
                                  }`}
                                >
                                  <span>
                                    {filteredAdress1.length === 1
                                      ? "1 produs"
                                      : `${filteredAdress1.length} produse`}
                                  </span>
                                  {isSelected1 ? (
                                    <HiChevronUp className="w-3 h-3" />
                                  ) : (
                                    <HiChevronDown className="w-3 h-3" />
                                  )}
                                </button>
                              ) : (
                                <span className="h-[24px] px-2.5 rounded-full bg-[#F1F5F9] dark:bg-gray-700/60 text-[#94A3B8] dark:text-gray-400 text-[11px] font-medium inline-flex items-center justify-center">
                                  Fără date
                                </span>
                              )}
                            </td>

                            {/* Actiuni Cell */}
                            <td className="px-4 py-3.5 whitespace-nowrap text-center">
                              <div className="inline-flex items-center justify-center gap-1">
                                <button
                                  type="button"
                                  onClick={() => setSelecteduser1(customer)}
                                  className="w-8 h-8 rounded-lg inline-flex items-center justify-center text-gray-400 hover:text-[#6755E8] hover:bg-[#F1EEFF] dark:hover:bg-gray-700 transition-colors cursor-pointer"
                                  title="Vezi profilul medicului"
                                  aria-label="Vezi profilul medicului"
                                >
                                  <HiOutlineUser className="w-4 h-4" />
                                </button>

                                {user?.role === "Admin" ? (
                                  <button
                                    type="button"
                                    onClick={() => setSelecteddeleteuser(customer)}
                                    className="w-8 h-8 rounded-lg inline-flex items-center justify-center text-gray-400 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/40 transition-colors cursor-pointer"
                                    title="Șterge asocierea medicului"
                                    aria-label="Șterge asocierea medicului"
                                  >
                                    <HiOutlineTrash className="w-4 h-4" />
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    onClick={() => setSelecteduser1(customer)}
                                    className="w-8 h-8 rounded-lg inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
                                    title="Mai multe opțiuni"
                                    aria-label="Mai multe opțiuni"
                                  >
                                    <HiEllipsisVertical className="w-4 h-4" />
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>

                          {/* Expanded Specialties Area */}
                          {isSelected && (
                            <tr className="bg-[#F8F9FC] dark:bg-gray-900/60">
                              <td colSpan="7" className="p-3 sm:px-5 sm:py-3 border-b border-[#ECEFF4] dark:border-gray-700/60">
                                <div className="space-y-1.5">
                                  {filteredAdress.map((item, idx) => {
                                    const matchdistrict = instcity
                                      .filter((i) => i.id === item.institution_in_adress_id)
                                      .map((i) => i.adress_id);

                                    const matchingCity1 = matchdistrict.length > 0
                                      ? city.find((i) => matchdistrict.includes(i.adress_id))
                                      : null;

                                    return (
                                      <div
                                        key={idx}
                                        className="bg-white dark:bg-gray-800 border border-[#E7EAF0] dark:border-gray-700/60 rounded-[8px] p-2.5 sm:px-3 grid grid-cols-1 sm:grid-cols-[0.9fr_1.2fr_1.1fr_1fr_0.9fr] gap-2.5 sm:gap-3 items-center shadow-[0_1px_3px_rgba(0,0,0,0.02)]"
                                      >
                                        {/* Specialty */}
                                        <div className="flex items-center gap-2 min-w-0">
                                          <HiOutlineSparkles className="w-3.5 h-3.5 text-[#7B6CF0] shrink-0" />
                                          <div className="min-w-0">
                                            <div className="text-[8.5px] font-medium text-[#9AA3B2] dark:text-gray-400">
                                              Specialitatea
                                            </div>
                                            <div className="text-[10.5px] sm:text-[11px] font-medium text-[#303A4D] dark:text-gray-200 truncate">
                                              {item.spec || "—"}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Institution */}
                                        <div className="flex items-center gap-2 min-w-0">
                                          <HiOutlineBuildingOffice2 className="w-3.5 h-3.5 text-[#7B6CF0] shrink-0" />
                                          <div className="min-w-0">
                                            <div className="text-[8.5px] font-medium text-[#9AA3B2] dark:text-gray-400">
                                              Instituția
                                            </div>
                                            <div className="text-[10.5px] sm:text-[11px] font-medium text-[#303A4D] dark:text-gray-200 truncate">
                                              {item.inst || "—"}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Address */}
                                        <div className="flex items-center gap-2 min-w-0">
                                          <HiOutlineMapPin className="w-3.5 h-3.5 text-[#7B6CF0] shrink-0" />
                                          <div className="min-w-0">
                                            <div className="text-[8.5px] font-medium text-[#9AA3B2] dark:text-gray-400">
                                              Adresă
                                            </div>
                                            <div className="text-[10.5px] sm:text-[11px] font-normal text-[#303A4D] dark:text-gray-200 truncate">
                                              {matchingCity1?.description || "—"}
                                            </div>
                                          </div>
                                        </div>

                                        {/* City */}
                                        <div className="flex items-center gap-2 min-w-0">
                                          <HiOutlineBuildingLibrary className="w-3.5 h-3.5 text-[#7B6CF0] shrink-0" />
                                          <div className="min-w-0">
                                            <div className="text-[8.5px] font-medium text-[#9AA3B2] dark:text-gray-400">
                                              Oraș
                                            </div>
                                            <div className="text-[10.5px] sm:text-[11px] font-normal text-[#303A4D] dark:text-gray-200 truncate">
                                              {matchingCity1?.city_name || "—"}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Region */}
                                        <div className="flex items-center gap-2 min-w-0">
                                          <HiOutlineGlobeEuropeAfrica className="w-3.5 h-3.5 text-[#7B6CF0] shrink-0" />
                                          <div className="min-w-0">
                                            <div className="text-[8.5px] font-medium text-[#9AA3B2] dark:text-gray-400">
                                              Regiunea
                                            </div>
                                            <div className="text-[10.5px] sm:text-[11px] font-normal text-[#303A4D] dark:text-gray-200 truncate">
                                              {matchingCity1?.district_name || "—"}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>
                            </tr>
                          )}

                          {/* Expanded Product Categorization Area */}
                          {isSelected1 && (
                            <tr className="bg-[#F8F9FC] dark:bg-gray-900/60">
                              <td colSpan="7" className="p-3 sm:px-5 sm:py-3 border-b border-[#ECEFF4] dark:border-gray-700/60">
                                <div className="space-y-1.5">
                                  {filteredAdress1.map((item, idx) => (
                                    <div
                                      key={idx}
                                      className="bg-white dark:bg-gray-800 border border-[#E7EAF0] dark:border-gray-700/60 rounded-[8px] p-2.5 sm:px-3 grid grid-cols-1 sm:grid-cols-3 gap-2.5 sm:gap-3 items-center shadow-[0_1px_3px_rgba(0,0,0,0.02)]"
                                    >
                                        {/* Product Name */}
                                        <div className="flex items-center gap-2 min-w-0">
                                          <HiOutlineCube className="w-3.5 h-3.5 text-[#7B6CF0] shrink-0" />
                                          <div className="min-w-0">
                                            <div className="text-[8.5px] font-medium text-[#9AA3B2] dark:text-gray-400">
                                              Produs
                                            </div>
                                            <div className="text-[10.5px] sm:text-[11px] font-medium text-[#303A4D] dark:text-gray-200 truncate">
                                              {item.product_name || "—"}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Product Category */}
                                        <div className="flex items-center gap-2 min-w-0">
                                          <HiOutlineTag className="w-3.5 h-3.5 text-[#7B6CF0] shrink-0" />
                                          <div className="min-w-0">
                                            <div className="text-[8.5px] font-medium text-[#9AA3B2] dark:text-gray-400">
                                              Categoria produs
                                            </div>
                                            <div className="text-[10.5px] sm:text-[11px] font-normal text-[#303A4D] dark:text-gray-200 truncate">
                                              {item.description || "—"}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Created timestamp */}
                                        <div className="flex items-center gap-2 min-w-0">
                                          <HiOutlineCalendarDays className="w-3.5 h-3.5 text-[#7B6CF0] shrink-0" />
                                          <div className="min-w-0">
                                            <div className="text-[8.5px] font-medium text-[#9AA3B2] dark:text-gray-400">
                                              Timpul creării
                                            </div>
                                            <div className="text-[10.5px] sm:text-[11px] font-normal text-[#303A4D] dark:text-gray-200 truncate">
                                              {item.created_timestamp
                                                ? dayjs(item.created_timestamp).format("DD-MM-YYYY")
                                                : "—"}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination Footer */}
              <div className="px-6 py-3.5 border-t border-[#F1F5F9] dark:border-gray-700/60 flex flex-col sm:flex-row items-center justify-between gap-3">
                <span className="text-xs font-medium text-[#64748B] dark:text-gray-400">
                  Total: {uniqueUsers.length} {uniqueUsers.length === 1 ? "doctor" : "doctori"}
                </span>

                <div className="flex items-center bg-[#F8FAFC] dark:bg-gray-800 p-1 rounded-lg border border-[#E2E8F0] dark:border-gray-700">
                  <button
                    type="button"
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                    className="w-7 h-7 flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 disabled:opacity-30 transition-colors cursor-pointer"
                  >
                    <HiChevronLeft className="w-3.5 h-3.5" />
                  </button>

                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
                    const isActive = page === currentPage;
                    if (
                      page === 1 ||
                      page === totalPages ||
                      (page >= currentPage - 1 && page <= currentPage + 1)
                    ) {
                      return (
                        <button
                          key={page}
                          type="button"
                          onClick={() => setCurrentPage(page)}
                          className={`w-7 h-7 flex items-center justify-center rounded-md text-xs font-medium transition-colors cursor-pointer ${
                            isActive
                              ? "bg-[#1E293B] text-white shadow-xs"
                              : "text-[#64748B] hover:text-[#1E293B] hover:bg-gray-100 dark:hover:bg-gray-700"
                          }`}
                        >
                          {page}
                        </button>
                      );
                    }
                    if (
                      (page === 2 && currentPage > 3) ||
                      (page === totalPages - 1 && currentPage < totalPages - 2)
                    ) {
                      return (
                        <span key={page} className="px-1 text-gray-400 text-xs">
                          ...
                        </span>
                      );
                    }
                    return null;
                  })}

                  <button
                    type="button"
                    onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className="w-7 h-7 flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 disabled:opacity-30 transition-colors cursor-pointer"
                  >
                    <HiChevronRight className="w-3.5 h-3.5" />
                  </button>
                </div>

                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-[#64748B] dark:text-gray-400">Arată:</span>
                  <select
                    className="h-[34px] min-w-[130px] rounded-lg border border-[#E2E8F0] hover:border-[#CBD5E1] dark:border-gray-600 bg-white dark:bg-gray-700 text-xs font-medium text-[#334155] dark:text-gray-200 pl-3 pr-8 py-1 focus:outline-none focus:border-[#6755E8] focus:ring-2 focus:ring-[#6755E8]/10 transition-all cursor-pointer"
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    <option value={5}>5 pe pagină</option>
                    <option value={10}>10 pe pagină</option>
                    <option value={15}>15 pe pagină</option>
                    <option value={uniqueUsers.length || 50}>Toate</option>
                  </select>
                </div>
              </div>
            </div>
          ) : (
            /* Empty State */
            <div className="py-14 px-6 text-center flex flex-col items-center justify-center min-h-[220px]">
              <div className="w-[52px] h-[52px] rounded-[14px] bg-[#F6F5FF] dark:bg-indigo-950/40 text-[#7B6CF0] dark:text-indigo-400 flex items-center justify-center mb-3 shadow-[0_2px_8px_rgba(103,85,232,0.06)]">
                <HiOutlineHeart className="w-6 h-6" />
              </div>
              <p className="text-[14px] font-semibold text-[#172033] dark:text-gray-200">
                Niciun doctor favorit
              </p>
              <p className="text-[11px] font-normal text-[#8D96A7] dark:text-gray-400 mt-1 max-w-xs leading-relaxed">
                Nu există medici asociați în acest moment pentru acest cont.
              </p>
              {user?.role === "Admin" && (
                <button
                  type="button"
                  onClick={handleOpenRows}
                  className="mt-4 h-[34px] px-3.5 rounded-[8px] bg-[#6755E8] hover:bg-[#5948D8] text-white text-[11px] font-medium inline-flex items-center gap-1.5 shadow-xs transition-colors cursor-pointer"
                >
                  <HiPlus className="w-3.5 h-3.5" />
                  <span>Adaugă doctor</span>
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default DashboardCard07physicians;